"use client";

import React, { useEffect, useState } from "react";
import { PaymentsProvider } from "../../../domain/types";
import { useWindowProperty } from "@/hooks/useWindowProperty";
import { TiptopWidget } from "../domain/types";
import { useUser } from "@clerk/nextjs";
import { useOrganizationStore } from "@/stores/organization.store";
import { TiptopPaymentModalApi } from "../domain/tiptop.api";
import { tiptopCommonStore, tiptopStore } from "../domain/store";

//

const publicId = process.env.NEXT_PUBLIC_TIPTOP_PUBLIC_ID;

//

export const TiptopProvider: PaymentsProvider = ({ children, fallback }) => {
  const tiptop = useWindowProperty("tiptop");
  const [paymentsInstance, setPaymentsInstance] = useState<TiptopWidget>();
  const { user } = useUser();
  const organization = useOrganizationStore();

  useEffect(() => {
    if (!tiptop) return;
    if (paymentsInstance) return;
    if (!user) return;

    const email = user.primaryEmailAddress?.emailAddress;

    const instance = new tiptop.Widget({
      language: "ru-RU",
      email: email ?? "",
      applePaySupport: true,
      googlePaySupport: true,
    });

    setPaymentsInstance(instance);
  }, [paymentsInstance, tiptop, user]);

  //

  return paymentsInstance && tiptop ? (
    <tiptopStore.Provider value={{ tiptop }}>
      <tiptopCommonStore.Provider
        value={{
          paymentModalApi: new TiptopPaymentModalApi(paymentsInstance, publicId, organization.id),
        }}
      >
        {children}
      </tiptopCommonStore.Provider>
    </tiptopStore.Provider>
  ) : (
    fallback
  );
};
